import React from "react";

const PresentationModeToggle = ({
  presentationMode,
  setPresentationMode,
  disabled = false,
}) => {
  return (
    <div className="w-full rounded-2xl border border-white/40 bg-white/80 backdrop-blur-sm shadow-lg shadow-blue-500/5 p-4">
     
      <fieldset className="space-y-2" disabled={disabled}>
        <label
          className={[
            "flex items-center gap-3 rounded-xl border px-3 py-3 cursor-pointer transition-all",
            !presentationMode
              ? "border-blue-300 bg-blue-50"
              : "border-gray-200 bg-white hover:bg-gray-50",
            disabled ? "opacity-50 cursor-not-allowed" : "",
          ].join(" ")}
        >
          <input
            type="radio"
            name="view-mode"
            checked={!presentationMode}
            onChange={() => setPresentationMode(false)}
            className="h-4 w-4 accent-blue-600"
            disabled={disabled}
          />
          <div className="min-w-0">
            <div className="text-sm font-semibold text-gray-900">Practice</div>
            <div className="text-xs text-gray-500">Full controls</div>
          </div>
        </label>

        <label
          className={[
            "flex items-center gap-3 rounded-xl border px-3 py-3 cursor-pointer transition-all",
            presentationMode
              ? "border-indigo-300 bg-indigo-50"
              : "border-gray-200 bg-white hover:bg-gray-50",
            disabled ? "opacity-50 cursor-not-allowed" : "",
          ].join(" ")}
        >
          <input
            type="radio"
            name="view-mode"
            checked={presentationMode}
            onChange={() => setPresentationMode(true)}
            className="h-4 w-4 accent-indigo-600"
            disabled={disabled}
          />
          <div className="min-w-0">
            <div className="text-sm font-semibold text-gray-900">Presentation</div>
            <div className="text-xs text-gray-500">Student view</div>
          </div>
        </label>
      </fieldset>
    </div>
  );
};

export default PresentationModeToggle;